export class Template {
    Id: number;
    Description: string;
    UnitIDs:Array<number> = new Array();
}
